import React, { Fragment, useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux';
import Box from '@mui/material/Box';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Button from 'react-bootstrap/Button';
import { formatDate } from '../../../common/utils';
import { createLeadOpp } from '../../../common/api';
import { toast } from 'react-toastify';

import '../modals.css';


const AddLeadOpp = ( { close, aid, uid, cid, contacts, pStatus, pSource, pPurpose } ) => {
    const [ desc, setDesc ] = useState();
    const [ oppDate, setOppDate ] = useState();
    const [ purpose, setPurpose ] = useState();
    const [ source, setSource ] = useState();
    const [ status, setStatus ] = useState();
    const [ ready, setReady ] = useState( false );

    const nameRef = useRef( null );

    useEffect( () => {
        nameRef.current.focus();
    }, [] );

    useEffect( () => {
        if ( desc && desc.length > 0 ) {
            setReady( true );
        } else {
            setReady( false );
        }
    }, [ desc ] );

    useEffect( () => {
        const today = new Date();
        setOppDate( formatDate( today ) );
        setPurpose( pPurpose.find( p => p.default ).value );
        setSource( pSource.find( p => p.default ).value );
        setStatus( pStatus.find( p => p.default ).value );
    }, [ pPurpose, pSource, pStatus ] );

    const create = async () => {
        const c = contacts[cid];
        const added = await createLeadOpp( c.aid, uid, desc, oppDate, purpose, source, status, [ { cid: cid } ] );
        if ( added.length ) {
            toast.success( `The Lead Opp has been added`, { theme: 'dark' } );
            close();
        }
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '450px',
        bgcolor: 'background.paper',
        border: '1px solid #000',
        p: 2,
        maxHeight: '95vh',
        overflowY: 'auto'
    };

    return (
        <Fragment>
            <Box sx={ { ...style, pt: 0 } }>
                <Row className='py-2' style={ { borderBottom: '1px solid var( --bs-border-color )' } }>
                    <Col className='tf-modal-title'>Create a New Lead Opportunity</Col>
                </Row>
                <Row className='pt-3 pb-2'>
                    <Col>
                        <Form.Group>
                            <Form.Label>Enter a brief description of this opportunity</Form.Label>
                            <Form.Control ref={nameRef} className='tf-modal-text-input' type="text" placeholder="Description of this Opportunity" value={desc} onChange={ ( e ) => setDesc( e.target.value ) } />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Form.Group>
                            <Form.Label>Starting date for this opportunity</Form.Label>
                            <Form.Control className='tf-modal-text-input' type="date" value={oppDate} onChange={ ( e ) => setOppDate( e.target.value ) } />
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Form.Group>
                            <Form.Label>Loan Purpose for this opportunity</Form.Label>
                            <Form.Select size='sm' className='tf-modal-text-input' value={purpose} onChange={ ( e ) => setPurpose( e.target.value ) }>
                                {
                                    pPurpose.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Form.Group>
                            <Form.Label>Current Status of this opportunity</Form.Label>
                            <Form.Select size='sm' className='tf-modal-text-input' value={status} onChange={ ( e ) => setStatus( e.target.value ) }>
                                {
                                    pStatus.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Form.Group>
                            <Form.Label>Source of this opportunity</Form.Label>
                            <Form.Select size='sm' className='tf-modal-text-input' value={source} onChange={ ( e ) => setSource( e.target.value ) }>
                                {
                                    pSource.map( ( p, idx ) => <option key={idx} value={p.value}>{p.label}</option>)
                                }
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row className='py-2'>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ () => create() } disabled={!ready}>Create</Button>
                    </Col>
                    <Col xs='auto'>
                        <Button size='sm' variant='outline-primary' onClick={ () => close() }>Cancel</Button>
                    </Col>
                </Row>
            </Box>
        </Fragment>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    cid: state.contacts.currentId,
    contacts: state.contacts.byId,
    pStatus: state.user.meta.global.picklist.status,
    pSource: state.user.meta.global.picklist.source,
    pPurpose: state.user.meta.global.picklist.purpose,
} );
  
const mapDispatch = ( dispatch ) => ( {
    // load: dispatch.lists.loadGroups,
} );
  
export default connect( mapProps, mapDispatch )( AddLeadOpp );